import {
  Builderlyags3ldja2y as Builder,
  Builder3vv3qt9kyowg0 as Builder_0,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.m6g_1 = (new (Builder())('input')).e3a();
        this.n6g_1 = (new (Builder())('input')).e3a();
        this.o6g_1 = (new (Builder())('input')).e3a();
        this.p6g_1 = (new (Builder())('input')).e3a();
        this.q6g_1 = (new (Builder())('input')).e3a();
        this.r6g_1 = (new (Builder())('input')).e3a();
        this.s6g_1 = (new (Builder())('input')).e3a();
        this.t6g_1 = (new (Builder())('input')).e3a();
        this.u6g_1 = (new (Builder())('input')).e3a();
        this.v6g_1 = (new (Builder())('input')).e3a();
        this.w6g_1 = (new (Builder())('input')).e3a();
        this.x6g_1 = (new (Builder())('input')).e3a();
        this.y6g_1 = (new (Builder())('input')).e3a();
        this.z6g_1 = (new (Builder())('input')).e3a();
        this.a6h_1 = (new (Builder())('input')).e3a();
        this.b6h_1 = (new (Builder())('input')).e3a();
        this.c6h_1 = (new (Builder())('input')).e3a();
        this.d6h_1 = (new (Builder())('input')).e3a();
        this.e6h_1 = (new (Builder())('input')).e3a();
        this.f6h_1 = (new (Builder())('input')).e3a();
        this.g6h_1 = (new (Builder_0())('Mutation')).e3a();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceoymipm3rjnhd,
};
//endregion

//# sourceMappingURL=Mutation.mjs.map
